import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControl,
  TextField,
  Paper,
  Button,
  IconButton,
  Tooltip,
  useTheme,
  LinearProgress,
  Select,
  MenuItem,
  InputLabel,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Breadcrumbs,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import * as Yup from "yup";
import {
  postData,
  getFetchData,
  requestMail,
  getLeaveentryData,
  getApprovallistData,
} from "../../../store/reducers/Formapireducer";
import { Formik } from "formik";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { tokens } from "../../../Theme";
import { LoadingButton } from "@mui/lab";
import { toast } from "react-hot-toast";
import {
  LeaveTypeAutocomplete,
  Productautocomplete,
} from "../../../ui-components/global/Autocomplete";
import {
  dataGridHeaderFooterHeight,
  dataGridRowHeight,
  formGap,
} from "../../../ui-components/global/utils";
import {
  leaveAppoval,
  mailNotify,
} from "../../../store/reducers/Listviewapireducer";
import FileListPopup from "../../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import {
  attachmentPost,
  fetchApidata,
} from "../../../store/reducers/LoginReducer";
import ViewListIcon from "@mui/icons-material/ViewList";
import GradingIcon from "@mui/icons-material/Grading";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import axios from "axios";
import store from "../../..";
import CryptoJS from "crypto-js";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";
import { DataGrid } from "@mui/x-data-grid";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { GridToolbarQuickFilter } from "@mui/x-data-grid";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";

// const validationSchema = Yup.object().shape({
//   leavetype: Yup.object().required(ErrorMsgData.Leave.leavetype).nullable(),
//   comments: Yup.string().required(ErrorMsgData.Leave.comments),
//   FromDate: Yup.string().required(ErrorMsgData.Leave.FromDate),
//   ToDate: Yup.string().required(ErrorMsgData.Leave.ToDate),
//   LeavePart: Yup.string().required(ErrorMsgData.Leave.LeavePart),
// });

const KEY = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse("1234567890123456"); // 16-byte IV

export function encryptDataUrlSafe(plainText) {
  const encrypted = CryptoJS.AES.encrypt(plainText, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(); // Standard base64

  // Convert to URL-safe base64
  return encrypted.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function decryptData(encryptedBase64) {
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64) },
    KEY,
    {
      iv: IV,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    },
  );

  return decrypted.toString(CryptoJS.enc.Utf8); // Original string
}
const Editleaveentry = (empId, appId) => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const getLoading = useSelector((state) => state.formApi.getLoading);
  // const data = useSelector((state) => state.formApi.Data);
  const Data = useSelector((state) => state.formApi.Data);
  const ListData = useSelector((state) => state.formApi.approvalList);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const header = useSelector((state) => state.formApi.Header);
  const isLoading = useSelector((state) => state.formApi.loading);
  const [loading, setLoading] = useState(false);
  const EMPID = sessionStorage.getItem("EmpId");
  const compID = sessionStorage.getItem("companyId");
  const dispatch = useDispatch();
  const recID = params.id;
  const mode = params.Mode;
  const accessID = params.accessID;
  const currentDate = new Date().toISOString().split("T")[0];
  const [selectedLeavetypebalance, setSelectedLeavetypebalance] = useState("");
  const [showtable, setShowtable] = useState(false);
  const [pageSize, setPageSize] = React.useState(10);
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);
  const [show, setScreen] = React.useState("0");
  const rowSx = { height: 36, "& td, & th": { py: 0.5 } };
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  
    const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");
  
  
  // const approvallistdata = useSelector((state) =>stata.
  const [files, setFiles] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [showImage, setShowImage] = useState(
    params.Mode == "IM" ? true : false,
  );
  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID })).then((res) => {
      console.log(res, "response");
      console.log(Data.EmployeeID, "response");
      var url = store.getState().globalurl.empGetAttachmentUrl;

      axios
        .get(url, {
          params: {
            empId: Data.EmployeeID,
            appId: Data.RecordID,
          },
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError("Failed to fetch attachments.");
          console.error(err);
        })
        .finally(() => setLoading(false));
    });
  }, []);
  // const validationSchema = Yup.object().shape({
  //   leavetype: Yup.object()
  //     .nullable()
  //     .required("Leave Type is required"),
  // });
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);
  console.log(validationSchema, "---validationSchema");

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
        const schema = Yup.object().shape({
          leavetype: Yup.object().required(data.Leave.leavetype).nullable(),
          comments: Yup.string().trim().required(data.Leave.comments),
          FromDate: Yup.string().required(data.Leave.FromDate),
          ToDate: Yup.string().required(data.Leave.ToDate),
          LeavePart: Yup.string().required(data.Leave.LeavePart),
          managerComments:
            mode === "M" ||
              (mode === "E" && (Data.Status === "RJ" || Data.Status === "QR"))
              ? Yup.string().required(data?.Leave?.managerComments).nullable()
              : Yup.string().notRequired(),

          Status: mode === "M" ? Yup.string().required(data.Leave.Status).nullable() : Yup.string().notRequired(),
          // managerComments: Yup.string().required(data.Leave.managerComments),
        });

        setValidationSchema(schema);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, [mode, Data.Status]);

  const screenChange = (event) => {
    setScreen(event.target.value);

    if (event.target.value == "1") {
      dispatch(getApprovallistData({ LeaveID: recID }));
    }

    if (event.target.value == "0") {
      dispatch(fetchApidata(accessID, "get", recID));
    }
  };

  const fnLogOut = (props) => {
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") navigate("/");
        if (props === "Close") navigate(-1);
      }
    });
  };
  const Approvalinitialvalues = {
    applieddate: header?.AppliedDate || "",
    // leavetype: header?.LeaveTypeID
    //   ? { RecordID: header.LeaveTypeID, Name: header.LeaveType }
    //   : null,
    leavetype: header?.LeaveType || "",
    autoapproval:
      header?.AutoApprovals == "Y"
        ? "Yes"
        : header?.AutoApprovals == "N"
          ? "No"
          : "",
    autoreject:
      header?.AutoRejection == "Y"
        ? "Yes"
        : header?.AutoRejection == "N"
          ? "No"
          : "",
  };
  // const leaveValidationSchema = Yup.object().shape({
  //   leavetype: Yup.object()
  // .nullable()
  // .required("Leave Type is required"),

  //   applieddate: Yup.string().required("Applied Date is required"),
  //   FromDate: Yup.string().required("From Date is required"),
  //   ToDate: Yup.string().required("To Date is required"),
  //   comments: Yup.string().required("Comments are required"),
  //   // add other fields as needed
  // });
  const leaveInitialValue = {
    applieddate: mode == "A" ? currentDate : Data.AppliedDate,
    RecordID: Data.RecordID,
    FromDate: Data.FromDate,
    ToDate: Data.ToDate,
    leavetype: Data.LeaveTypeID
      ? { RecordID: Data.LeaveTypeID, Name: Data.LeaveTypeName }
      : null,
    LeavePart: mode == "A" ? "N" : Data.LeavePart,
    BalanceDay: Data.BalanceDays,
    comments: Data.Comments,
    managerComments: mode == "M" ? Data.ManagerComments : "",
    Status: mode === "M" ? "" : Data.Status,
    SortOrder: "1",
    Disable: "N",
  };

  const appliedYearLookup = new Date(
    leaveInitialValue.applieddate,
  ).getFullYear();
  const Balancedayfind = async (LeaveTypeID) => {
    try {
      const appliedYear = new Date(leaveInitialValue.applieddate).getFullYear();
      const response = await dispatch(
        getLeaveentryData({
          EmployeeID: EMPID,
          LeaveTypeID: LeaveTypeID,
          Year: appliedYear,
        }),
      );

      console.log(response, "--find response lookup");

      const balancedayvaluefind = response.payload.Data;
      console.log(balancedayvaluefind, "--balancedayvaluefind");
      setSelectedLeavetypebalance(response.payload.Data.ELC_ELIGIBLEDAYS);
      console.log(selectedLeavetypebalance, "--selectedLeavetypebalance");

      // return balancedayvaluefind; // optional if needed
    } catch (error) {
      console.error("Error in Balancedayfind:", error);
    }
  };

  const leaveFNsave = async (values, resetForm, del) => {
    setLoading(true);
    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
          ? "harddelete"
          : "update";
    const idata = {
      RecordID: recID,
      FromDate: values.FromDate,
      ToDate: values.ToDate,
      LeavePart: values.LeavePart,
      Comments: values.comments,
      ManagerComments: values.managerComments,
      EmployeeID: mode == "M" ? params.parentID : EMPID,
      Status:
        mode == "A"
          ? "AL"
          : Data.Status == "QR" && values.Status == "QR"
            ? "RA"
            : values.Status,
      AppliedDate: values.applieddate,
      SortOrder: "1",
      Disable: "N",
      Source: "Self",
      LeaveTypeID: values.leavetype.RecordID || 0,
      LeaveTypeName: values.leavetype.Name || "",
      BalanceDay: selectedLeavetypebalance || values.BalanceDay,
      ApprovedBy: EMPID,
    };

    const response = await dispatch(
      postData({ accessID: "TR208", action, idata }),
    );
    if (response.payload.Status == "Y") {
      console.log("---calling response payload");

      setLoading(false);
      if (mode == "A") {
        dispatch(
          requestMail({
            EmployeeID: EMPID,
            Type: "L",
            RecordID: response.payload.EleaveRecid,
            encryptData: encryptDataUrlSafe(response.payload.EleaveRecid),
          }),
        );
        dispatch(
          leaveAppoval({
            data: {
              RecordID: response.payload.EleaveRecid,
              ManagerID: "",
              EmployeeID: EMPID,
              Type: "L",
              Status: "AL",
              Reason: "",
            },
          }),
        );
      }
      if (mode == "M") {
        dispatch(
          leaveAppoval({
            data: {
              RecordID: recID,
              ManagerID: EMPID,
              EmployeeID: params.parentID,
              Type: "L",
              Status:
                values.Status === "AP"
                  ? "Y"
                  : values.Status === "QR"
                    ? values.Status
                    : "N",

              Reason: values.managerComments,
              Source: "M",
            },
          }),
        );
        dispatch(
          mailNotify({
            RecordID: recID,
            ManagerID: EMPID,
            EmployeeID: params.parentID,
            Type: "L",
            Status:
              values.Status === "AP"
                ? "Y"
                : values.Status === "QR"
                  ? values.Status
                  : "N",

            Reason: values.managerComments,
            Source: "M",
          }),
        );
      }

      toast.success(response.payload.Msg);
      navigate(-1);
      resetForm();
    } else {
      setLoading(false);
      toast.error(response.payload.Msg);
    }
  };
  const columns = [
    // {
    //   field: "SLNO",
    //   headerName: "SL#",
    //   width: 50,
    //   headerAlign: "center",
    //   align: "right",
    // },

    {
      field: "slno",
      headerName: "SL#",
      width: 50,
      sortable: false,
      filterable: false,
      valueGetter: (params) =>
        `${params.api.getRowIndexRelativeToVisibleRows(params.id) + 1}`,
    },
    {
      field: "ManagerName",
      headerName: "Manager",
      width: 200,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "ManagerLevel",
      headerName: "Level",
      width: 50,
      headerAlign: "center",
      align: "right",
    },
    {
      field: "Status",
      headerName: "Status",
      width: 200,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "ApprovalComments",
      headerName: "Comment",
      width: 400,
      headerAlign: "center",
      align: "left",
    },
    {
      field: "ApprovalDate",
      headerName: "Approved Date",
      width: 200,
      headerAlign: "center",
      align: "center",
    },
  ];

  function Custombar() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          <Typography>List of Approvals</Typography>
          <Typography variant="h5">{`(${rowCount})`}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
        </Box>
      </GridToolbarContainer>
    );
  }
  async function fileUpload(file, EMPID, action, id, purpose) {
    setLoading(true);
    const formData = new FormData();
    formData.append("file", file);
    formData.append("empId", Data.EmployeeID);
    formData.append("appId", Data.RecordID);
    formData.append("type", "L");
    formData.append("source", "Self");
    formData.append("action", action);
    formData.append("id", id);
    formData.append("purpose", purpose ? purpose : "");
    const respose = await dispatch(attachmentPost({ data: formData }));

    if (respose.payload.success) {
      toast.success(respose.payload.message);
      //setShowtable(true);
      var url = store.getState().globalurl.empGetAttachmentUrl;
      axios
        .get(url, {
          params: {
            empId: Data.EmployeeID,
            appId: Data.RecordID,
          },
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError("Failed to fetch attachments.");
          console.error(err);
        })
        .finally(() => setLoading(false));
    } else {
      toast.success(respose.payload.message);
    }

    console.log("🚀 ~ fileUpload ~ respose:", respose);
  }
  return (
    <React.Fragment>
      {getLoading && <LinearProgress />}
      {loading && <LinearProgress />}
      <Paper
        elevation={3}
        sx={{ margin: "0px 10px", background: "#F2F0F0", height: "50px" }}
      >
        <Box display="flex" justifyContent="space-between">
          {/* SEARCH BAR */}
          <Box display="flex" borderRadius="3px" alignItems={"center"}>
            {broken && !rtl && (
              <IconButton onClick={() => toggleSidebar()}>
                <MenuOutlinedIcon />
              </IconButton>
            )}
            <Box
              display={isNonMobile ? "flex" : "none"}
              borderRadius="3px"
              alignItems="center"
            >
              <Breadcrumbs
                maxItems={3}
                aria-label="breadcrumb"
                separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
              >
                <Typography
                  variant="h3"
                  color="#000000de"
                  sx={{ marginLeft: "10px", fontSize: "19px",color: "#0000D1" }}
                  onClick={() => {
                    setScreen(0);
                  }}
                >
                  {is003Subscription ? "Leave Request" : "Leave Entry"}
                  
                </Typography>

                {show == "1" ? (
                  <Typography
                    variant="h5"
                    color="#0000D1" 
                    sx={{ cursor: "default", fontSize: "19px" }}
                  >
                    Approval Lists
                  </Typography>
                ) : (
                  false
                )}
              </Breadcrumbs>
            </Box>
          </Box>

          <Box display="flex">
            {mode !== "A" ? (
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">Explore</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={show}
                  label="Explore"
                  onChange={screenChange}
                >
                  <MenuItem value={0}>Leave Entry</MenuItem>

                  <MenuItem value={1}>Approval List</MenuItem>

                  {/* <MenuItem value={8}>Change Password</MenuItem> */}
                </Select>
              </FormControl>
            ) : (
              false
            )}

            <Tooltip title="Close">
              <IconButton onClick={() => fnLogOut("Close")} color="error">
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton onClick={() => fnLogOut("Logout")} color="error">
                <LogoutOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>

      {show == "0" && !getLoading ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          {mode === "IM" && (
            <Box
              display="flex"
              padding={1}
              justifyContent="flex-end"
              mt="2px"
              gridColumn="span 4"
              gap={2}
              marginBottom={-5}
            >
              <IconButton onClick={() => setShowImage((prev) => !prev)}>
                <ArrowDownwardIcon sx={{ color: "blue" }} />
              </IconButton>
            </Box>
          )}

          <Formik
            initialValues={leaveInitialValue}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                leaveFNsave(values, resetForm, false);
              }, 100);
            }}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              resetForm,
              setFieldValue,
              setFieldTouched,
            }) => (
              <form
                onSubmit={handleSubmit}
                onReset={() => {
                  resetForm();
                }}
              >
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <FormControl sx={{ gridColumn: "span 2", gap: "15px" }}>
                    <TextField
                      name="applieddate"
                      type="date"
                      id="applieddate"
                      label="Applied Date"
                      variant="standard"
                      focused
                      inputFormat="YYYY-MM-DD"
                      value={values.applieddate}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.applieddate && !!errors.applieddate}
                      helperText={touched.applieddate && errors.applieddate}
                      sx={{ gridColumn: "span 2" }}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                        readOnly: true,
                      }}
                      disabled={
                        mode === "M" ||
                        (mode == "E" &&
                          values.Status != "AL" &&
                          values.Status != "QR")
                      }
                    />
                    {/* <Productautocomplete
                      name="leavetype"
                      label={
                        <>
                          Leave Type<span style={{ color: "red" }}> *</span>
                        </>
                      }
                      id="leavetype"

                      value={values.leavetype}
                      onChange={async (newValue) => {
                        setFieldValue("leavetype", newValue);
                        if (newValue?.RecordID) {
                          await Balancedayfind(newValue.RecordID);
                        }
                      }}
                      onBlur={() => setFieldTouched("leavetype", true)}
                      disabled={
                        mode == "E" &&
                        values.Status != "AL" &&
                        values.Status != "RA" &&
                        values.Status != "QR"
                      }

                      // "Filter":"parentID='${compID}' AND EmployeeID='${EMPID}'" ,
                      url={`${listViewurl}?data={"Query":{"AccessID":"2107","ScreenName":"Leave Type","Filter":"parentID='${compID}' AND EmployeeID='${EMPID}'","Any":""}}`}
                    />
                    {touched.leavetype && errors.leavetype && (
                      <div style={{ color: "red", fontSize: "12px", marginTop: "-8px" }}>
                        {errors.leavetype}
                      </div>
                    )} */}
                    <LeaveTypeAutocomplete
                      name="leavetype"
                      label={
                        <>
                          Leave Type
                          <span style={{ color: "red", fontSize: "20px" }}>
                            {" "}
                            *{" "}
                          </span>
                        </>
                      }
                      id="leavetype"
                      // required
                      value={values.leavetype}
                      onChange={async (newValue) => {
                        setFieldValue("leavetype", newValue);
                        if (newValue?.RecordID) {
                          await Balancedayfind(newValue.RecordID);
                        }
                      }}
                      disabled={
                        mode === "M" ||
                        (mode == "E" &&
                          values.Status != "AL" &&
                          values.Status != "RA" &&
                          values.Status != "QR")
                      }
                      error={!!touched.leavetype && !!errors.leavetype}
                      helperText={touched.leavetype && errors.leavetype}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2107","ScreenName":"Leave Type","Filter":"parentID='${compID}' AND EmployeeID='${EMPID}' AND Year='${appliedYearLookup}'","Any":""}}`}
                    />

                    {!showImage ? (
                      <React.Fragment>
                        <FormControl
                          focused
                          variant="filled"
                          sx={{ gridColumn: "span 2" }}
                          disabled={
                            mode === "M" ||
                            (mode == "E" &&
                              values.Status != "AL" &&
                              values.Status != "RA" &&
                              values.Status != "QR")
                          }
                        >
                          <InputLabel variant="standard" id="LeavePart">
                            <>
                              Leave Part
                              <span style={{ color: "red", fontSize: "20px" }}>
                                {" "}
                                *{" "}
                              </span>
                            </>
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-filled-label"
                            fullWidth
                            variant="standard"
                            type="text"
                            value={values.LeavePart}
                            id="LeavePart"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            name="LeavePart"
                            error={!!touched.LeavePart && !!errors.LeavePart}
                            helperText={touched.LeavePart && errors.LeavePart}
                            focused
                          >
                            <MenuItem value="FH">First Half</MenuItem>
                            <MenuItem value="SH">Second Half</MenuItem>
                            <MenuItem value="N">Full Day</MenuItem>
                          </Select>
                        </FormControl>
                        <TextField
                          disabled={
                            mode === "M" ||
                            (mode == "E" &&
                              values.Status != "AL" &&
                              values.Status != "RA" &&
                              values.Status != "QR")
                          }
                          name="FromDate"
                          type="date"
                          id="FromDate"
                          label={
                            <>
                              From Date
                              <span style={{ color: "red", fontSize: "20px" }}>
                                {" "}
                                *{" "}
                              </span>
                            </>
                          }
                          variant="standard"
                          InputLabelProps={{ shrink: true }}
                          focused
                          value={values.FromDate}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.FromDate && !!errors.FromDate}
                          helperText={touched.FromDate && errors.FromDate}
                          // required
                          sx={{ gridColumn: "span 2" }}
                        />
                        <TextField
                          disabled={
                            mode === "M" ||
                            (mode == "E" &&
                              values.Status != "AL" &&
                              values.Status != "RA" &&
                              values.Status != "QR")
                          }
                          name="ToDate"
                          type="date"
                          id="ToDate"
                          label={
                            <>
                              To Date
                              <span style={{ color: "red", fontSize: "20px" }}>
                                {" "}
                                *{" "}
                              </span>
                            </>
                          }
                          variant="standard"
                          InputLabelProps={{ shrink: true }}
                          focused
                          value={values.ToDate}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.ToDate && !!errors.ToDate}
                          helperText={touched.ToDate && errors.ToDate}
                          // required
                          sx={{ gridColumn: "span 2" }}
                          inputProps={{
                            min:
                              values.FromDate ||
                              new Date().toISOString().split("T")[0],
                          }}
                        />
                        <TextField
                          fullWidth
                          variant="standard"
                          type="number"
                          label="Balance Days"
                          id="BalanceDay"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={selectedLeavetypebalance || values.BalanceDay}
                          name="BalanceDay"
                          disabled={
                            mode === "M" ||
                            (mode == "E" &&
                              values.Status != "AL" &&
                              values.Status != "RA" &&
                              values.Status != "QR")
                          }
                          focused
                          onWheel={(e) => e.target.blur()}
                          InputProps={{
                            readOnly: true,
                            inputProps: {
                              style: { textAlign: "right" },
                            },
                          }}
                        />
                        <TextField
                          disabled={
                            mode === "M" ||
                            (mode == "E" &&
                              values.Status != "AL" &&
                              values.Status != "RA" &&
                              values.Status != "QR")
                          }
                          fullWidth
                          variant="outlined"
                          type="text"
                          label={
                            <>
                              Comments
                              <span style={{ color: "red", fontSize: "20px" }}>
                                {" "}
                                *{" "}
                              </span>
                            </>
                          }
                          // required
                          multiline
                          rows={6}
                          value={values.comments}
                          id="comments"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          name="comments"
                          error={!!touched.comments && !!errors.comments}
                          helperText={touched.comments && errors.comments}
                          sx={{
                            gridColumn: "span 2",
                            backgroundColor: "",
                            "& .MuiFilledInput-root": {
                              backgroundColor: "",
                            },
                          }}
                          focused
                        />

                        {mode == "M" ||
                          (mode == "E" &&
                            (values.Status == "RJ" || values.Status == "QR")) ? (
                          <TextField
                            disabled={mode == "E" && values.Status != "AL"}
                            fullWidth
                            variant="outlined"
                            type="text"
                            // label="Manager Comments"
                            label={
                              <>
                                Manager Comments
                                <span
                                  style={{ color: "red", fontSize: "20px" }}
                                >
                                  {" "}
                                  *{" "}
                                </span>
                              </>
                            }
                            // required
                            multiline
                            rows={6}
                            value={values.managerComments}
                            id="managerComments"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            error={
                              !!touched.managerComments &&
                              !!errors.managerComments
                            }
                            helperText={
                              touched.managerComments && errors.managerComments
                            }
                            name="managerComments"
                            sx={{
                              gridColumn: "span 2",
                            }}
                            focused
                          />
                        ) : (
                          false
                        )}
                        {mode == "M" && (
                          <TextField
                            select
                            label={
                              <>
                                Status<span style={{ color: "red", fontSize: "20px" }}> * </span>
                              </>
                            }
                            id="Status"
                            name="Status"
                            value={values.Status}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            error={Boolean(errors.Status)}
                            helperText={errors.Status}
                            focused
                            variant="standard"
                          >
                            {mode != "M" && (
                              <MenuItem value="AL">Applied</MenuItem>
                            )}
                            <MenuItem disabled={mode != "M"} value="AP">
                              Approved
                            </MenuItem>
                            <MenuItem disabled={mode != "M"} value="RJ">
                              Rejected
                            </MenuItem>
                            {mode == "M" && (
                              <MenuItem value="QR">Query</MenuItem>
                            )}
                          </TextField>
                        )}

                        {mode == "E" && values.Status == "AP" && (
                          <Alert
                            variant="filled"
                            sx={{ mt: 1 }}
                            severity="success"
                          >
                            Your Leave Request has been Approved.
                            {Data.AutoProcess == "Y" ? "(Auto)" : false}
                          </Alert>
                        )}
                        {mode == "E" && values.Status == "RJ" && (
                          <Alert
                            variant="filled"
                            sx={{ mt: 1 }}
                            severity="error"
                          >
                            Your Leave Request has been Rejected.
                            {Data.AutoProcess == "Y" ? "(Auto)" : false}
                          </Alert>
                        )}

                        {mode == "E" && values.Status == "QR" && (
                          <Alert
                            variant="filled"
                            sx={{ mt: 1 }}
                            severity="warning"
                          >
                            Your Leave Request has been Queried.
                            {Data.AutoProcess == "Y" ? "(Auto)" : false}
                          </Alert>
                        )}
                      </React.Fragment>
                    ) : (
                      false
                    )}
                  </FormControl>

                  <Box
                    display="flex"
                    padding={1}
                    justifyContent="flex-end"
                    gridColumn="span 4"
                    //mt="40px"
                    gap={2}
                  >
                    {/* {mode === "E" ? (
                      <Box display="flex" alignItems="center" gap={1}>
                        <FileUploadIconButton onFileSelect={fileUpload} />
                      </Box>
                    ) : null} */}
                    {mode == "IM" && (
                      <>
                        <TextField
                          name="purpose"
                          type="text"
                          id="purpose"
                          label="Purpose"
                          variant="standard"
                          focused
                          value={values.purpose}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.purpose && !!errors.purpose}
                          helperText={touched.purpose && errors.purpose}
                          sx={{ gridColumn: "span 2", height: "20px" }}
                          InputLabelProps={{ shrink: true }}
                        />

                        <Box display="flex" alignItems="center" gap={1}>
                          <FileUploadIconButton
                            onFileSelect={(file) => {
                              fileUpload(
                                file,
                                Data.EmployeeID,
                                "upload",
                                "",
                                values.purpose,
                              );
                              setFieldValue("purpose", "");
                            }}
                          />
                        </Box>
                      </>
                    )}
                    {mode != "M" &&
                      (values.Status == "AL" ||
                        values.Status == "QR" ||
                        mode == "A") && (
                        <LoadingButton
                          disabled={mode == "IM"}
                          color="secondary"
                          variant="contained"
                          type="submit"
                          loading={isLoading}
                        >
                          Save
                        </LoadingButton>
                      )}
                    {mode == "M" && (
                      <LoadingButton
                        disabled={mode == "IM"}
                        color="secondary"
                        variant="contained"
                        type="submit"
                        loading={isLoading}
                      >
                        Save
                      </LoadingButton>
                    )}
                    {mode != "M" && values.Status == "AL" && (
                      <Button
                        color="error"
                        variant="contained"
                        disabled={mode == "IM"}
                        onClick={() => {
                          Swal.fire({
                            title: errorMsgData.Warningmsg.Delete,
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Confirm",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              leaveFNsave(values, resetForm, "harddelete");
                              // navigate(-1);
                            } else {
                              return;
                            }
                          });
                        }}
                      >
                        Delete
                      </Button>
                    )}
                    {/* {mode == "M" && (
                      <Button
                        color="error"
                        variant="contained"
                        onClick={() => {
                          Swal.fire({
                            title: `Do you want Delete?`,
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            confirmButtonText: "Confirm",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              leaveFNsave(values, resetForm, "harddelete");
                              // navigate(-1);
                            } else {
                              return;
                            }
                          });
                        }}
                      >
                        Delete
                      </Button>
                    )} */}
                    <Button
                      type="reset"
                      color="warning"
                      variant="contained"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      Cancel
                    </Button>
                  </Box>
                  <FileListPopup
                    open={open}
                    onClose={() => setOpen(false)}
                    appId={recID}
                    empId={EMPID}
                  />
                </Box>
              </form>
            )}
          </Formik>
        </Paper>
      ) : (
        false
      )}
      {show == "1" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          {/* <Box m="20px" sx={{ m: 2 }}> */}
          <Formik
            // onSubmit={handleFormSubmit}
            initialValues={Approvalinitialvalues}
            enableReinitialize={true}
          // onSubmit={(values, { resetForm }) => {
          //   setTimeout(() => {
          //     FnApproval(values, resetForm, false);
          //   }, 100);
          // }}
          >
            {({
              values,
              errors,
              touched,
              handleBlur,
              handleSubmit,
              handleChange,
              resetForm,
            }) => (
              <form
                onSubmit={handleSubmit}
                onReset={() => {
                  //selectCellRowData({ rowData: {}, mode: "A", field: "" });
                  resetForm();
                }}
              >
                <Box>
                  <Box
                    display="grid"
                    gap={formGap}
                    padding={1}
                    gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                    sx={{
                      "& > div": {
                        gridColumn: isNonMobile ? undefined : "span 4",
                      },
                    }}
                  >
                    <FormControl sx={{ gridColumn: "span 2", gap: formGap }}>
                      <TextField
                        name="applieddate"
                        type="date"
                        id="applieddate"
                        label="Applied Date"
                        variant="standard"
                        focused
                        inputFormat="YYYY-MM-DD"
                        value={values.applieddate}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.applieddate && !!errors.applieddate}
                        helperText={touched.applieddate && errors.applieddate}
                        sx={{ background: "" }}
                        inputProps={{ readOnly: true }}
                        InputLabelProps={{ shrink: true }}
                      />
                      <TextField
                        variant="standard"
                        type="text"
                        id="leavetype"
                        name="leavetype"
                        value={values.leavetype}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        label="Leave Type"
                        focused
                        inputProps={{ readOnly: true }}
                      />
                      <TextField
                        variant="standard"
                        type="text"
                        id="autoapproval"
                        name="autoapproval"
                        value={values.autoapproval}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        label="Auto Approval"
                        focused
                        inputProps={{ readOnly: true }}
                      />
                      <TextField
                        variant="standard"
                        type="text"
                        id="autoreject"
                        name="autoreject"
                        value={values.autoreject}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        label="Auto Reject"
                        focused
                        inputProps={{ readOnly: true }}
                      />
                    </FormControl>
                  </Box>
                  <Box
                    m="5px 0 0 0"
                    height="500px"
                    sx={{
                      "& .MuiDataGrid-root": {
                        // border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        // borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        // borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        // borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                      "& .odd-row": {
                        backgroundColor: "",
                        color: "", // Color for odd rows
                      },
                      "& .even-row": {
                        backgroundColor: "#d0edec",
                        color: "", // Color for even rows
                      },
                    }}
                  >
                    <DataGrid
                      sx={{
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      // checkboxSelection
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      rows={ListData}
                      columns={columns}
                      disableSelectionOnClick
                      getRowId={(row) => row.SLNO}
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      // onCellClick={(params) => {
                      //   selectCellRowData({
                      //     rowData: params.row,
                      //     mode: "E",
                      //     field: params.field,
                      //   });
                      // }}
                      rowsPerPageOptions={[5, 10, 20]}
                      pagination
                      components={{
                        Toolbar: Custombar,
                      }}
                      onStateChange={(stateParams) =>
                        setRowCount(stateParams.pagination.rowCount)
                      }
                      loading={exploreLoading}
                      componentsProps={{
                        toolbar: {
                          showQuickFilter: true,
                          quickFilterProps: { debounceMs: 500 },
                        },
                      }}
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                    />
                  </Box>
                </Box>
                {/* </FormControl> */}
                {/* <Box
                  display="flex"
                  padding={1}
                  justifyContent="end"
                  // mt="70px"
                  gap={2}
                >
                 
                  <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={isLoading}
                    disabled
                  >
                    Save
                  </LoadingButton>
                  <Button type="reset" color="warning" variant="contained">
                    Cancel
                  </Button>
                </Box> */}
              </form>
            )}
          </Formik>
          {/* </Box> */}
        </Paper>
      ) : (
        false
      )}
      {show === "0" && mode === "IM" && files.length > 0 ? (
        <Box mt={2}>
          <Paper elevation={3} sx={{ padding: 2 }}>
            {/* <Typography variant="h6" gutterBottom>
              Uploaded Files
            </Typography> */}
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={rowSx}>
                    <TableCell width={20}>
                      <strong>SL#</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Uploaded Date</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Filename</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Purpose</strong>
                    </TableCell>
                    <TableCell>
                      <strong>Source</strong>
                    </TableCell>
                    <TableCell>
                      <strong>View</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {files.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No files uploaded yet.
                      </TableCell>
                    </TableRow>
                  ) : (
                    files.map((file, index) => (
                      <TableRow key={file.id || index} sx={rowSx}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{file.uploadedDate}</TableCell>
                        <TableCell>{file.filename}</TableCell>
                        <TableCell>{file.purpose}</TableCell>
                        <TableCell>{file.source}</TableCell>
                        <TableCell>
                          <Tooltip title="Open File">
                            <IconButton
                              color="primary"
                              component="a"
                              href={file.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              size="small"
                            >
                              <OpenInNewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="delete">
                            <IconButton
                              color="error"
                              onClick={() =>
                                fileUpload(
                                  file.filename,
                                  Data.EmployeeID,
                                  "delete",
                                  file.id,
                                  file.purpose,
                                )
                              }
                              size="small"
                            >
                              <DeleteForeverIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      ) : null}
    </React.Fragment>
  );
};

export default Editleaveentry;
